<template>
  <el-dialog :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="true"
             :close-on-press-escape="false" custom-class="bind-dd-container" width="400px">
    <div class="bind-container">
      <div class="bind-title">扫码绑定钉钉</div>
      <div class="bind-code">
        <!--    背景图    -->
        <img class="bind-bg" src="../../assets/images/bind-dd-bg.png" alt=""/>
        <!--    二维码IMG    -->
        <bind-d-d-q-r-code :key="key" @success="success"/>
        <div class="scan-line"/>
      </div>
      <div style="margin-top: 10px; font-size: 12px;color: #45474d;">
        欢迎使用星广汇
        &nbsp; <span class="refresh" @click="refreshCode"><i class="el-icon-refresh"/>刷新</span>
      </div>
      <div style="margin-bottom: 10px; font-size: 12px;color: #8a8e99">
        温馨提醒：请使用手机端钉钉APP扫码绑定
      </div>
    </div>
  </el-dialog>
</template>

<script>
import BindDDQRCode from "@/components/BindDingDing/qrcode.vue";
import {getAuthUser, getToken} from "@/utils/auth";

/**
 * ① 登录状态
 * ② 未绑定钉钉
 * ③ 指定页面
 */
export default {
  name: "BindDingDing",
  components: {BindDDQRCode},
  data() {
    return {
      dialogVisible: false,
      key: new Date().getTime()
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 默认不弹窗
      this.dialogVisible = false

      // ① 登录状态
      const is_login = getToken()
      if (!is_login) {
        // 未登录不需要弹窗
        return;
      }
      // ② 绑定状态
      const {is_bind_dd} = getAuthUser()
      if (parseInt(is_bind_dd)) {
        // 已绑定不需要
        return;
      }
      if (localStorage.getItem('showBindDD')) {
        // 已弹窗
        return;
      }

      this.dialogVisible = true
      localStorage.setItem('showBindDD', '1');

    },
    success() {
      this.dialogVisible = false
      this.$emit('success')
    },
    refreshCode() {
      this.key = new Date().getTime()
    },
    handleClose(){
      this.dialogVisible = false
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss">
.bind-dd-container {
  border-radius: 10px !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    border-radius: 10px;
  }

  .refresh {
    color: #ff3176;
    cursor: pointer;
  }

  .bind-container {
    text-align: center;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;


    @keyframes scanning {
      from {
        top: 0;
      }
      to {
        top: 200px;
      }
    }

    @-webkit-keyframes scanning /*Safari and Chrome*/
    {
      from {
        top: 0;
      }
      to {
        top: 200px;
      }
    }

    .bind-title {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 20px;
    }

    .bind-code {
      position: relative;
      height: 200px;
      width: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      overflow: hidden;

      .bind-bg {
        width: 200px;
        height: 200px;
        position: absolute;
        z-index: 3;
      }

      .scan-line {
        height: 3px;
        width: 100%;
        background-image: linear-gradient(90deg, #fff, #fe346e 30%, #fe346e 70%, #fff);
        position: absolute;
        top: 0;
        z-index: 2;
        animation: scanning 3s linear infinite;
      }
    }
  }
}
</style>
